<template>
  <div class="header">
    <div class="header-one">
      <div class="brand">
        <template v-if="catName.length > 0">
          <el-tag v-for="item in catName"
                  :key="item.cat_id"
                  color="#FF7D00"
                  class="keyWords">
            {{language == 'zh' ? item.name : item.name_en}}
          </el-tag>
          <el-tag v-if="omit"
                  color="#FF7D00"
                  class="keyWords">
            ...
          </el-tag>
        </template>

        <span> > </span>
        <el-tag v-if="brandName"
                class="keyWords"
                color="#69C0FF"
                v-html="brandName">
        </el-tag>
        <span v-if="brandName"> > </span>
        <span v-if="postWord"
              class="postword"
              v-html="postWord">
        </span>
        <span>|</span>
        <span class="follow"> <span>
            <i class="iconfont icon-heart iconBox"
               v-show="isFollow"
               @click="followClick(1)"></i>
            <i class="iconfont icon-heart-fill red iconBox"
               v-show="!isFollow"
               @click="followClick(0)"></i>
          </span>+{{$t('mainHead.follow')}}</span>
      </div>
      <div class="time-pick">
        <div style="margin: 0 8px"
             v-if="userVersionSelected && isShowUserCoupon">
          <el-select v-model="version"
                     placeholder="请选择"
                     size="mini"
                     style="width: 140px"
                     @change="versionChange">
            <el-tooltip class="item"
                        effect="dark"
                        :content="item.date"
                        :disabled="!item.disabled"
                        placement="right-start"
                        v-for="item in couponList"
                        :key="item.value">
              <el-option :value="item.value"
                         :label="item.name"
                         :disabled="item.disabled"></el-option>
            </el-tooltip>
          </el-select>
        </div>
        <div style="display: inline-block; margin: 0 8px"
             v-if="isShowJdVersion">
          <el-select v-model="jdVersion"
                     @change="jdVersionChange"
                     placeholder="请选择"
                     size="mini"
                     style="width: 140px">
            <el-option v-for="item in jdVersionList"
                       :key="item.value"
                       :value="item.value"
                       :label="item.name"></el-option>
          </el-select>
        </div>
        <span style="margin:0 6px 0 12px">{{$t('headSearch.month')}}：</span>
        <div class="thrMonCheck">
          <el-radio-group v-if="!socialPlat"
                          v-model="thrMonRadio"
                          @input="handleChangeMonth">
            <el-radio :label="'oneMonth'">
              {{$t('headSearch.oneMonth')}}
            </el-radio>
            <el-radio :label="'lastThreeMonths'">
              {{$t('headSearch.lastThreeMonths')}}
            </el-radio>
          </el-radio-group>
        </div>
        <el-select v-model="ts"
                   size="small"
                   :disabled="isDisabled"
                   placeholder="请选择"
                   @change="changeTs"
                   style="width:120px">
          <el-option v-for="(item,index) in timeList"
                     :key="index"
                     :label="item"
                     :value="item">
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="header-two">
      <!-- <div style="width:100%"> -->
      <el-tabs v-model="editableTabsValue"
               type="card"
               @tab-click="handleTabClick">
        <el-tab-pane :key="item.name"
                     v-for="(item) in editableTabsList"
                     :label="item.title"
                     :name="item.name">

        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import {
  getWordTs,
  setMarked,
  getSearchMarked,
  getJdWordTs,
  getCatName,
  getTbJdWordTs,
} from '@/api/public'
import { parseTime, getUrlParams, getQueryObject, build_ts } from '@/utils'
export default {
  data() {
    return {
      ts: this.$store.state.user.ts,
      ts_min: '',
      timeList: [],
      parseTime: parseTime,
      dialogVisible: false,
      loading: false,
      loading_save: false,
      brandOptions: [],
      searchForm: {
        KeyWards: this.$store.getters.selectedKeyWards,
        brand: this.$store.state.user.selectedType,
      },
      editableTabs: [
        {
          title: this.$t('mainHead.tabs_trend'),
          name: 'TrendList',
          isShow: true,
        },
        {
          title: this.$t('mainHead.tabs_category'),
          name: 'CategoryList',
          isShow: true,
        },
        {
          title: this.$t('mainHead.tabs_brand'),
          name: 'BrandList',
          isShow: true,
        },
        {
          title: this.$t('mainHead.tabs_commodity'),
          name: 'CommodityList',
          isShow: true,
        },
      ],
      postWord: this.$store.state.user.selectedKeyWards,
      catName: [],
      cid: this.$store.state.user.cat_id,
      brandName: this.$store.state.user.brand_name,
      param_val: getQueryObject(window.location.href),
      editableTabsValue: 'TrendList',
      ActivedTabArr: [],
      isFollow: true,
      isDisabled: false,
      plat: 'all',
      omit: false,
      couponList: [
        { name: this.$t('mainHeader.no_discount'), value: '' },
        {
          name: this.$t('mainHeader.discount_v1'),
          value: 'cp',
          date: '2020年1月起',
        },
        {
          name: this.$t('mainHeader.full_discount_v2'),
          value: 'min_v2',
          date: '2020年11月起',
        },
      ],
      loginInfo: this.$store.state.user.loginInfo,
      version: this.$store.state.user.version,
      userVersionSelected: this.$store.state.user.loginInfo
        ? this.$store.state.user.loginInfo.version_selected || []
        : [],
      isMoojingUser: false,
      isShowCoupon: false,
      isShowUserCoupon: false,
      isShowJdVersion: false,
      jdVersion: this.$store.state.user.jdVersion,
      jdVersionList: [
        {
          name: 'sold_v4_c1',
          value: 'sold_v4_c1'
        },
        {
          name: 'sold_v2_c',
          value: 'sold_v2_c'
        },
        {
          name: 'sold_v4_c2',
          value: 'sold_v4_c2'
        },
        {
          name: 'sold_v5_c',
          value: 'sold_v5_c'
        },
        {
          name: 'sold_v6_c',
          value: 'sold_v6_c'
        }
      ],
      thrMonRadio: 'oneMonth',
      isMultiMonth: false,
      startTime: '',
      endTime: '',
      socialPlat: getQueryObject(window.location.hash).social_plat
    }
  },
  methods: {
    followClick(val) {
      const query = getQueryObject(window.location.href)
      let param = {
        category_id: this.cid,
        func: val,
        type: 'word',
        word: query.word_source
          ? query.word_source
          : this.$store.state.user.selectedKeyWards.replace(
            /^["|'](.*)["|']$/g,
            '$1'
          ),
        platform: this.plat,
      }
      const jd_cat1 = query.jd_cat1
      if (jd_cat1 && jd_cat1 != 'undefined') {
        param.jd_cat1 = jd_cat1
      }
      setMarked(param)
        .then((res) => {
          if (res.status == 'ok') {
            this.isFollow = !this.isFollow
            this.$message.success('设置成功')
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch((e) => {
          if (e.data.error_msg && e.data.error_msg.msg) {
            this.$message.error(e.data.error_msg.msg)
          } else if (e.data.error_msg) {
            this.$message.error(e.data.error_msg)
          }
        })
    },
    changeActivedTabArr() {
      var self = this
      for (var i = 0; i < self.editableTabs.length; i++) {
        Vue.set(self.editableTabs[i], 'isShow', true)
      }
      if (this.ActivedTabArr && this.ActivedTabArr.length > 0) {
        this.ActivedTabArr.forEach(function (item) {
          Vue.set(self.editableTabs[item], 'isShow', false)
        })
      }
    },
    getTs() {
      let getWordTsMethod = null
      const param = {
        plat: this.plat
      }
      if (this.plat == 'jd') {
        getWordTsMethod = getJdWordTs
      } else if (this.plat == 'tbjddy') {
        getWordTsMethod = getTbJdWordTs
      } else {
        getWordTsMethod = getWordTs
      }
      getWordTsMethod(param)
        .then((res) => {
          if (res.status == 'ok') {
            this.ts = res.result.ts
            this.ts_min = res.result.ts_min
            this.timeList = build_ts(res.result.ts, this.ts_min)
            const query = getQueryObject(window.location.hash)
            if (query.end) {
              this.ts = query.end
            }
            localStorage.setItem('ts', res.result.ts)
            localStorage.setItem('ts_start', res.result.ts)
            localStorage.setItem('ts_end', res.result.ts_min)
          } else {
            this.$message.error('请求失败')
          }
        })
        .catch((e) => {
          // this.$message.success('删除失败')
        })
    },
    getMarked() {
      getSearchMarked({
        category_id: this.cid,
        word: getQueryObject(window.location.href).word_source
          ? getQueryObject(window.location.href).word_source
          : this.$store.state.user.selectedKeyWards.replace(
            /^["|'](.*)["|']$/g,
            '$1'
          ),
        plat: this.plat,
      })
        .then((res) => {
          if (res.status == 'ok') {
            if (res.result.data.monitor_flag == '1') {
              this.isFollow = false
            } else {
              this.isFollow = true
            }
          } else {
            this.$message.error('请求失败')
          }
        })
        .catch((e) => {
          // this.$message.success('删除失败')
        })
    },
    /* type:查询类型  id:通过id精确查询，name：通过名称模糊查询 */
    handleTabClick(tab, event) {
      localStorage.setItem('passActivedTab', tab.name)
      this.$store.dispatch('user/changeActivedTab', tab.name)
    },
    changeTs(val) {
      if (!val) {
        this.$message.warning(this.$t('mainHead.rules_message_range'))
        this.ts = this.$store.state.user.ts
        return
      } else if (this.isMultiMonth == true || this.isMultiMonth == 'true') {
        const year = Number(val.split('-')[0])
        const month = Number(val.split('-')[1])
        if (month == 1 || month == 2) {
          let newYear = year - 1
          let newMonth = month == 1
            ? 11
            : 12
          this.startTime = newYear.toString() + '-' + newMonth.toString()
          this.endTime = val
        } else if (month == 12) {
          let newMonth = month - 2
          this.startTime = year.toString() + '-' + newMonth.toString()
          this.endTime = val
        } else {
          let newMonth = month - 2
          this.startTime = year.toString() + '-0' + newMonth.toString()
          this.endTime = val
        }
      } else {
        this.startTime = val
        this.endTime = val
      }
      const query = getQueryObject(window.location.href)
      query.cid = this.cid
      query.word = query.word_source || this.postWord || query.word
      query.ts = this.ts
      query.start = this.startTime
      query.end = this.endTime
      query.plat = this.plat
      query.is_multi_month = this.isMultiMonth
      const jd_cat1 = query.jd_cat1
      if (jd_cat1 && jd_cat1 !== 'undefined') {
        query.jd_cat1 = jd_cat1
      }
      const dy_cat1 = query.dy_cat1
      if (dy_cat1 && dy_cat1 !== 'undefined') {
        query.dy_cat1 = dy_cat1
      }
      localStorage.setItem('ts', this.ts)
      this.$store.dispatch('user/changeTs', this.ts)
      this.$router.push({
        name: 'detail',
        query,
      })
    },
    handlePlantChange() {
      this.$store.dispatch('user/changeplants', this.checkList)
    },
    buildVerList() {
      let self = this
      var verList = this.userVersionSelected
      if ( this.isMoojingUser || (this.loginInfo.username && this.loginInfo.username.endsWith('@moojing.com')) ) {
        this.isShowUserCoupon = true
      } else {
        if (!verList || verList.length == 0) {
          this.isShowUserCoupon = false
        } else {
          let arr = []
          _.map(verList, function (v) {
            let item = _.find(self.couponList, function (o) {
              return o.value == v
            })
            if (item) {
              arr.push(item)
            }
          })
          this.couponList = arr
          this.version = arr[0].value
          this.$store.dispatch('user/changeVersion', this.version)
          this.$eventBus.$emit('versionChange', this.version)
          this.isShowUserCoupon = true
        }
      }
    },
    versionChange(val) {
      this.$eventBus.$emit('versionChange', val)
      this.$store.dispatch('user/changeVersion', val)
    },
    jdVersionChange(val) {
      this.$eventBus.$emit('jdVersionChange', val)
      this.$store.dispatch('user/changeJdVersion', val)
    },
    platVersionShow(val) {
      this.isShowUserCoupon = false
      this.isShowJdVersion = false
      const query = getQueryObject(window.location.hash)
      if (!query.social_plat) {
        if (this.plat == 'douyin' || this.plat == 'gamazon' || this.plat == 'jd') {
          this.isShowUserCoupon = false
        } else {
          this.userVersionSelected = this.loginInfo.version_selected
          this.buildVerList()
        }
        if (this.plat == 'jd' && this.loginInfo.jd_version) {
          this.jdVersionList = []
          this.loginInfo.jd_version.forEach(item => {
            this.jdVersionList.push({
              name: item,
              value: item
            })
          })
          if (this.jdVersionList && this.jdVersionList.length > 0) {
            this.jdVersion = this.jdVersionList[0].value
            this.$store.dispatch('user/changeJdVersion', this.jdVersion)
            this.$eventBus.$emit('jdVersionChange', this.jdVersion)
            this.isShowJdVersion = true
          }
        }
      }
    },
    handleChangeMonth(val) {
      const { end } = getQueryObject(window.location.href)
      if (val == 'lastThreeMonths') {
        this.isMultiMonth = true
        this.$store.dispatch('user/changeIsMultiMonth', this.isMultiMonth)
        this.changeTs(end)
      } else {
        this.isMultiMonth = false
        this.$store.dispatch('user/changeIsMultiMonth', this.isMultiMonth)
        this.changeTs(end)
      }
    }
  },
  computed: {
    editableTabsList: function () {
      return this.editableTabs.filter(function (item) {
        return item.isShow //返回isShow=true的项，添加到activeUsers数组
      })
    },
    language() {
      return localStorage.getItem('language')
    },
  },
  created() {
    this.setOneGet = _.debounce(this.getMarked, 500)
    if (getUrlParams('monitor_flag') && getUrlParams('monitor_flag') == '1') {
      this.isFollow = false
    }
    if (this.language == 'zh') {
      this.postWord = getUrlParams('word_source')
    } else {
      this.postWord = getUrlParams('word')
    }
    if (getUrlParams('plat')) {
      this.plat = getUrlParams('plat')
    }
    if (getUrlParams('cid')) {
      this.cid = getUrlParams('cid')
    }
    this.getTs()
    this.$eventBus.$on('summaryDataLoading', (val) => {
      //这里是防止频繁切换时间发送请求
      this.isDisabled = val
    })
    const params = {
      plat: this.plat,
      cat: this.cid,
      site_lang: this.$i18n.locale,
    }
    getCatName(params).then((res) => {
      if (res.result.data.length > 3) {
        this.catName = res.result.data.slice(0, 3)
        this.omit = true
      } else {
        this.catName = res.result.data
        this.omit = false
      }
    })
  },
  mounted() {
    this.getMarked()
  },
  watch: {
    '$store.state.user.brand_name': {
      handler(newVal, oldVal) {
        this.brandName = newVal
      },
    },
    '$store.state.user.selectedKeyWards': {
      handler(newVal, oldVal) {
        this.searchForm.KeyWards = newVal
        this.postWord = newVal
        this.setOneGet()
      },
    },
    '$store.state.user.ActivedTab': {
      handler(newVal, oldVal) {
        this.editableTabsValue = newVal
      },
    },
    '$store.state.user.ActivedTabArr': {
      handler(newVal, oldVal) {
        this.ActivedTabArr = newVal
        this.changeActivedTabArr()
      },
    },
    '$route.query': {
      handler(newVal) {
        this.plat = getUrlParams('plat')
        this.cid = getUrlParams('cid')
        if (this.language == 'zh') {
          this.postWord = getUrlParams('word_source')
        } else {
          this.postWord = getUrlParams('word')
        }
        this.isMultiMonth = getUrlParams('is_multi_month')
        this.thrMonRadio = this.isMultiMonth == 'true'
          ? 'lastThreeMonths'
          : 'oneMonth'
        this.getTs()
        const params = {
          plat: this.plat,
          cat: this.cid,
          site_lang: this.$i18n.locale,
        }
        getCatName(params).then((res) => {
          if (res.result.data.length > 3) {
            this.catName = res.result.data.slice(0, 3)
            this.omit = true
          } else {
            this.catName = res.result.data
            this.omit = false
          }
        })
        this.platVersionShow()
      },
    },
    '$store.state.user.loginInfo': {
      handler(newVal, oldVal) {
        this.isMoojingUser = newVal.username.endsWith('@moojing.com')
        this.loginInfo = newVal
        this.platVersionShow()
      },
    },
  },
}
</script>

<style scoped lang='less'>
.keyWords {
  color: #fff;
}
.postword {
  color: #252525;
}
.follow {
  color: #85868a;
}
.iconBox {
  cursor: pointer;
  margin-right: 4px;
}
.lb {
  display: inline-block;
}
.red {
  color: #ff7875;
}
.thrMonCheck {
  margin-right: 10px;
}
</style>
